// SPDX-License-Identifier: MIT
export const TAU = Math.PI * 2;
export const clamp = (x: number, lo = 0, hi = 1): number => (x < lo ? lo : x > hi ? hi : x);
export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;
export const invLerp = (a: number, b: number, x: number): number => (b === a ? 0 : clamp((x - a) / (b - a)));
export const remap = (x: number, a0: number, a1: number, b0: number, b1: number): number => lerp(b0, b1, invLerp(a0, a1, x));
export const fract = (x: number): number => x - Math.floor(x);
export const smoothstep = (a: number, b: number, x: number): number => {
    const t = invLerp(a, b, x);
    return t * t * (3 - 2 * t);
};
/** 0→1→0 window: rises over [a, b], holds, falls over [c, d]. */
export const window4 = (a: number, b: number, c: number, d: number, x: number): number => Math.min(smoothstep(a, b, x), 1 - smoothstep(c, d, x));
